import { DocsBlockDefinition, DocumentationLegacyConfiguration, DocumentationLegacyItemType, ResourceFont, TokenUtils, } from "../../exports";
import { Asset } from "../../model/assets/SDKAsset";
import { BootstrapData } from "../../model/base/SDKBootstrapData";
import { Brand } from "../../model/base/SDKBrand";
import { DesignSystem, } from "../../model/base/SDKDesignSystem";
import { DesignSystemCollection } from "../../model/base/SDKDesignSystemCollection";
import { DesignSystemContactList } from "../../model/base/SDKDesignSystemContactList";
import { DesignSystemMemberList } from "../../model/base/SDKDesignSystemMemberList";
import { DesignSystemVersion, DesignSystemVersionCreate, DesignSystemVersionCreationJob, } from "../../model/base/SDKDesignSystemVersion";
import { DesignSystemVersionStats } from "../../model/base/SDKDesignSystemVersionStats";
import { DocumentationLegacy, } from "../../model/base/SDKDocumentationLegacy";
import { CodeComponent } from "../../model/code-components/SDKCodeComponent";
import { DocsAnalyticsData } from "../../model/docs_analytics/SDKDocsAnalyticsData";
import { ElementDataView } from "../../model/elements/SDKElementDataView";
import { ElementProperty, ElementPropertyTargetElementType, } from "../../model/elements/SDKElementProperty";
import { ElementPropertyValue } from "../../model/elements/values/SDKElementPropertyValue";
import { Exporter, } from "../../model/exporters/SDKExporter";
import { Pipeline } from "../../model/exporters/SDKPipeline";
import { ExporterCustomBlock } from "../../model/exporters/custom_blocks/SDKExporterCustomBlock";
import { ExportBuild } from "../../model/exporters/exporter_builds/SDKExportBuild";
import { ExportBuildResultLog } from "../../model/exporters/exporter_builds/SDKExportBuildResults";
import { ImportJob } from "../../model/jobs/SDKImportJob";
import { Membership } from "../../model/membership/SDKMembership";
import { ChatThread } from "../../model/messaging/SDKChatThread";
import { ChatThreadMessage, } from "../../model/messaging/SDKChatThreadMessage";
import { ForgeAgent } from "../../model/projects/SDKForgeAgent";
import { ForgeProject } from "../../model/projects/SDKForgeProject";
import { ForgeProjectArtifact } from "../../model/projects/SDKForgeProjectArtifact";
import { ForgeProjectContext } from "../../model/projects/SDKForgeProjectContext";
import { ForgeProjectFeature } from "../../model/projects/SDKForgeProjectFeature";
import { ForgeProjectFeatureArtifact } from "../../model/projects/SDKForgeProjectFeatureArtifact";
import { ForgeProjectFeatureArtifactList } from "../../model/projects/SDKForgeProjectFeatureArtifactList";
import { ForgeProjectFeatureMessage } from "../../model/projects/SDKForgeProjectFeatureMessage";
import { ForgeProjectFeatureMessageList } from "../../model/projects/SDKForgeProjectFeatureMessageList";
import { ForgeProjectFeatureMessageReaction } from "../../model/projects/SDKForgeProjectFeatureMessageReaction";
import { ForgeProjectMembership } from "../../model/projects/SDKForgeProjectMembership";
import { ResourceAsset } from "../../model/resources/SDKResourceAsset";
import { StorybookEntry, } from "../../model/storybook/SDKStorybookEntry";
import { CustomDomain } from "../../model/support/SDKCustomDomain";
import { FigmaStructure } from "../../model/support/SDKFigmaStructure";
import { FigmaStructureDetail } from "../../model/support/SDKFigmaStructureDetail";
import { Source } from "../../model/support/SDKSource";
import { User } from "../../model/users/SDKUser";
import { UserMembership } from "../../model/users/SDKUserMembership";
import { UserWorkspaceNotificationSettings, } from "../../model/users/SDKUserWorkspaceNotificationSettings";
import { Workspace } from "../../model/workspaces/SDKWorkspace";
import { WorkspaceIPWhitelistSettings, } from "../../model/workspaces/SDKWorkspaceIPWhitelistSettings";
import { WorkspaceIntegration, WorkspaceIntegrations, } from "../../model/workspaces/SDKWorkspaceIntegration";
import { GitProviderEndpoints, } from "../../model/workspaces/SDKWorkspaceIntegrationGetGitProviders";
import { WorkspaceIntegrationOauthRequest, } from "../../model/workspaces/SDKWorkspaceIntegrationOauthRequest";
import { WorkspaceInvitation, } from "../../model/workspaces/SDKWorkspaceInvitation";
import { WorkspaceInvoice } from "../../model/workspaces/SDKWorkspaceInvoice";
import { WorkspaceNPMRegistrySettings, } from "../../model/workspaces/SDKWorkspaceNPMRegistrySettings";
import { WorkspaceOnboarding, } from "../../model/workspaces/SDKWorkspaceOnboarding";
import { PortalSettings } from "../../model/workspaces/SDKWorkspacePortalSettings";
import { WorkspaceProduct } from "../../model/workspaces/SDKWorkspaceProduct";
import { SubscriptionProductFeatures } from "../../model/workspaces/SDKWorkspaceProductFeatures";
import { WorkspaceSSOSettings, } from "../../model/workspaces/SDKWorkspaceSSOSettings";
import { WorkspaceSubscription, } from "../../model/workspaces/SDKWorkspaceSubscription";
import { GitProvidersBranches, } from "../../model/workspaces/integrations/GitProvidersBranches";
import { GitProvidersOrganizations, } from "../../model/workspaces/integrations/GitProvidersOrganizations";
import { GitProvidersProjects, } from "../../model/workspaces/integrations/GitProvidersProjects";
import { GitProvidersRepositories, } from "../../model/workspaces/integrations/GitProvidersRepositories";
import { sortUsingMap, sureOf } from "../../utils/CommonUtils";
import { RawUtils } from "../../utils/RawUtils";
import { AssetGroupResolver } from "../resolvers/SDKAssetGroupResolver";
import { ComponentGroupResolver } from "../resolvers/SDKComponentGroupResolver";
import { ComponentResolver } from "../resolvers/SDKComponentResolver";
import { DocumentationLegacyItemResolver } from "../resolvers/SDKDocumentationItemResolver";
import { TokenGroupResolver } from "../resolvers/SDKTokenGroupResolver";
import { TokenResolver } from "../resolvers/SDKTokenResolver";
import { DataCoreAIRequests } from "./requests/SDKDataCoreAIRequests";
import { DataCoreReadRequests } from "./requests/SDKDataCoreReadRequests";
import { DataCoreRenderRequests, } from "./requests/SDKDataCoreRenderRequests";
import { DataCoreWriteRequests } from "./requests/SDKDataCoreWriteRequests";
import { v4 as uuidv4 } from "uuid";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Function Definition
export class DataCore {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(bridge) {
        this.bridge = bridge;
        this.read = new DataCoreReadRequests(bridge);
        this.write = new DataCoreWriteRequests(bridge);
        this.render = new DataCoreRenderRequests(bridge);
        this.ai = new DataCoreAIRequests(bridge);
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Aux
    /** Only for internal functionality */
    getBridgeInternal() {
        return this.bridge;
    }
    async fetch(url, init) {
        const invoker = this.bridge.getFetchInvoker();
        return invoker(url, init);
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Bootstrap data
    async bootstrapData(preferredWorkspaceId, preferredDesignSystemId, preferredVersionId, preferredBrandId) {
        const data = await this.read.getRemoteBootstrapData(preferredWorkspaceId, preferredDesignSystemId, preferredVersionId, preferredBrandId);
        return new BootstrapData(data);
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Multiplayer
    /** Remote: Get single-use multiplayer token */
    async multiplayerToken(room) {
        const data = await this.read.getRemoteMultiplayerToken(room);
        return data;
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - AI
    async invokeAmy(workspaceId, designSystemId, versionId, prompt, chatId) {
        return this.ai.invokeAmy(workspaceId, designSystemId, versionId, prompt, chatId);
    }
    async invokeAgent(agent, prompt, projectId, branchId) {
        return this.ai.invokeAgent(agent, prompt, projectId, branchId);
    }
    /** Remote: Retrieves executable url for various AI tasks */
    async executableTaskUrl(task) {
        return this.ai.executableTaskUrl(task);
    }
    /** Remote: Summarizes text using AI */
    async summarizeText(text, options) {
        return this.ai.summarizeText(text, options);
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Users
    /** Remote: Get information about currently logged in user */
    async currentUser() {
        const data = await this.read.getRemoteCurrentUser();
        return new User(data);
    }
    /** Remote: Get information about a specific user */
    async user(userId) {
        const data = await this.read.getRemoteUser(userId);
        return new User(data);
    }
    /** Remote: Get information about all workspaces user has access to, including which role they play */
    async memberships(userId) {
        const data = await this.read.getRemoteMemberships(userId);
        return data.map((m) => new Membership(m));
    }
    /** Remote: Get information about all workspaces user has access to, including which role they play */
    async userMemberships(workspaceId) {
        const data = await this.read.getRemoteUserMemberships(workspaceId);
        return data.map((m) => new UserMembership(m));
    }
    /** Remote: Get information about user workspace notification settings */
    async userWorkspaceNotificationSettings(userId, workspaceId) {
        const data = await this.read.getRemoteUserWorkspaceNotificationSettings(userId, workspaceId);
        return new UserWorkspaceNotificationSettings(data);
    }
    /** Deletes the user by id. Can only really delete its own user */
    async deleteUser(userId) {
        return this.write.deleteRemoteUser(userId);
    }
    /** Checks whether user can be deleted or not. Can only really check its own user */
    async canDeleteUser(userId) {
        return this.write.canDeleteRemoteUser(userId);
    }
    /** Logs out user. Can only really logout its own user */
    async logoutCurrentUser() {
        return this.write.logoutRemoteCurrentUser();
    }
    /** Updates the user profile of specified user. Can only really update its own user */
    async updateUserProfile(userId, profile) {
        return this.write.updateRemoteUserProfile(profile, userId);
    }
    /** Updates the avatar of the current user */
    async updateUserAvatar(userId, avatar) {
        return this.write.updateRemoteUserAvatar(userId, avatar);
    }
    /** Updates the avatar of the current user */
    async deleteUserAvatar(userId) {
        return this.write.deleteRemoteUserAvatar(userId);
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Elements: Base
    /** Download all necessary data for element property definitions and retrieve them resolved */
    async elementPropertyDefinitions(designSystemId, versionId, type) {
        // Batch requests together
        const data = await Promise.all([
            this.read.getRemoteElementPropertyDefinitions(designSystemId, versionId),
            this.elementViews(designSystemId, versionId, type),
        ]);
        const elementPropertyData = data[0];
        const elementViews = data[1];
        let resolvedProperties = elementPropertyData.map((p) => new ElementProperty(p));
        // Sort properties using views so they come in correct order to client
        const firstView = sureOf(elementViews.filter((v) => v.isDefault)[0]);
        const indexes = new Map();
        for (const column of firstView.columns) {
            if (column.propertyDefinitionId) {
                indexes.set(column.propertyDefinitionId, firstView.columns.indexOf(column));
            }
        }
        resolvedProperties = sortUsingMap(resolvedProperties, indexes, (p) => p.id).filter((p) => p.targetElementType === type);
        return resolvedProperties;
    }
    /** Download all necessary data for element property values and retrieve them resolved */
    async elementPropertyValues(designSystemId, versionId) {
        const data = await this.read.getRemoteElementPropertyValues(designSystemId, versionId);
        const resolvedValues = data.map((v) => new ElementPropertyValue(v));
        return resolvedValues;
    }
    /** Download all necessary data for element views and retrieve them resolved */
    async elementViews(designSystemId, versionId, type) {
        const data = await this.read.getRemoteElementDataViewDefinitions(designSystemId, versionId);
        const resolvedViews = data.map((v) => new ElementDataView(v));
        return resolvedViews.filter((v) => v.targetElementType === type);
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Token collections
    async tokenCollections(designSystemId, versionId) {
        const data = await this.read.getRemoteTokenCollections(designSystemId, versionId);
        return data.map((m) => new DesignSystemCollection(m));
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Elements: Tokens
    /** Download all necessary data for tokens and retrieve them resolved */
    async tokens(designSystemId, versionId, filter) {
        // Batch requests together
        const data = await Promise.all([
            this.read.getRemoteTokens(designSystemId, versionId, filter),
            this.tokenGroups(designSystemId, versionId),
            this.elementPropertyDefinitions(designSystemId, versionId, ElementPropertyTargetElementType.token),
            this.elementPropertyValues(designSystemId, versionId),
            this.elementViews(designSystemId, versionId, ElementPropertyTargetElementType.token),
            this.designSystemSources(designSystemId),
        ]);
        const tokenData = data[0];
        const tokenGroups = data[1];
        const elementPropertyDefinitions = data[2];
        const elementPropertyValues = data[3];
        const elementViews = data[4];
        const sources = data[5];
        const resolver = new TokenResolver(designSystemId, versionId);
        const tokens = resolver.resolveTokenData(tokenData, tokenGroups, elementPropertyDefinitions, elementViews, elementPropertyValues, sources);
        return tokens;
    }
    /** Download all necesssary data for token usage and retrieve them resolved */
    async getTokenUsage(designSystemId, versionId, idInVersion) {
        const usageData = await this.read.getRemoteTokenUsage(designSystemId, versionId, idInVersion);
        const mappedData = {
            tokens: usageData.tokens.map((t) => t.persistentId),
            components: usageData.components.map((c) => c.persistentId),
            documentationPages: usageData.documentationPages.map((d) => d.persistentId),
        };
        return mappedData;
    }
    /** Write new token to remote */
    async createToken(designSystemId, versionId, token, parentId) {
        const tokenWriteObject = token.toWriteObject();
        tokenWriteObject.groupPersistentId = parentId;
        const remoteToken = await this.write.createRemoteToken(designSystemId, versionId, tokenWriteObject);
        return {
            id: remoteToken.persistentId,
            idInVersion: remoteToken.id,
        };
    }
    /** Update existing token in remote */
    async updateToken(designSystemId, versionId, token) {
        const tokenWriteObject = token.toWriteObject();
        await this.write.updateRemoteToken(designSystemId, versionId, tokenWriteObject);
    }
    /** Write new token group to remote */
    async createTokenGroup(designSystemId, versionId, group, parentId) {
        const groupWriteObject = group.toWriteObject();
        groupWriteObject.parentId = parentId;
        const remoteGroup = await this.write.createRemoteTokenGroup(designSystemId, versionId, groupWriteObject);
        return {
            // @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
            id: remoteGroup.persistentId,
            // @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
            idInVersion: remoteGroup.id,
        };
    }
    /** Update existing token in remote */
    async updateTokenGroup(designSystemId, versionId, group) {
        const tokenGroupWriteObject = group.toWriteObject();
        await this.write.updateRemoteTokenGroup(designSystemId, versionId, tokenGroupWriteObject);
    }
    /** Download all necessary data for token groups and retrieve them resolved */
    async tokenGroups(designSystemId, versionId, filter) {
        const tokenGroupData = await this.read.getRemoteTokenGroups(designSystemId, versionId, filter);
        const resolver = new TokenGroupResolver();
        return resolver.resolveGroupData(tokenGroupData);
    }
    /** Write new token theme to remote */
    async createTokenTheme(designSystemId, versionId, theme) {
        const themeWriteObject = theme.toWriteObject();
        const remoteTheme = await this.write.createRemoteTokenTheme(designSystemId, versionId, themeWriteObject);
        return {
            id: remoteTheme.persistentId,
            // @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
            idInVersion: remoteTheme.id,
        };
    }
    /** Download all necessary data for token themes and retrieve them resolved */
    async themes(designSystemId, versionId, filter) {
        // Batch requests together
        const data = await Promise.all([
            this.read.getRemoteTokenThemes(designSystemId, versionId, filter),
            this.tokens(designSystemId, versionId, filter),
            this.tokenGroups(designSystemId, versionId, filter),
            this.designSystemSources(designSystemId, filter),
        ]);
        const themeData = data[0];
        const tokens = data[1];
        const tokenGroups = data[2];
        const sources = data[3];
        const resolvedThemes = new Array();
        for (const themeModel of themeData) {
            const resolver = new TokenResolver(designSystemId, versionId);
            const result = resolver.resolveThemeData(themeModel, tokens, tokenGroups, sources);
            resolvedThemes.push(result);
        }
        return resolvedThemes;
    }
    /** Update existing token theme in remote */
    async updateTokenTheme(designSystemId, versionId, theme) {
        const tokenThemeWriteObject = theme.toWriteObject();
        await this.write.updateRemoteTokenTheme(designSystemId, versionId, tokenThemeWriteObject);
    }
    async createThemeOverrideForToken(designSystemId, versionId, themeId, override) {
        return this.write.createThemeOverrideForToken(designSystemId, versionId, themeId, override);
    }
    /** Update theme override for token */
    async updateThemeOverrideForToken(designSystemId, versionId, tokenPersistentId, themeId, override) {
        return this.write.updateThemeOverrideForToken(designSystemId, versionId, tokenPersistentId, themeId, override);
    }
    /** Delete theme override for token */
    async deleteThemeOverrideForToken(designSystemId, versionId, tokenId, themeId) {
        return this.write.deleteThemeOverrideForToken(designSystemId, versionId, tokenId, themeId);
    }
    /** Write the tokens to remote */
    async writeTokenData(designSystemId, versionId, tokens, groups, deleteTokens, deleteGroups) {
        return this.write.writeTokenData(designSystemId, versionId, tokens.map((t) => t.toWriteObject()), groups.map((g) => g.toWriteObject()), deleteTokens, deleteGroups);
    }
    async writeTokenThemeData(designSystemId, versionId, theme) {
        const themeModel = theme.toWriteObject();
        return this.write.writeTokenThemeData(designSystemId, versionId, themeModel);
    }
    /** Delete token from remote */
    async deleteToken(designSystemId, versionId, tokenId) {
        return this.write.deleteRemoteToken(designSystemId, versionId, tokenId);
    }
    /** Delete group from remote */
    async ungroupTokenGroup(designSystemId, versionId, groupId) {
        return this.write.ungroupRemoteTokenGroup(designSystemId, versionId, groupId);
    }
    /** Delete group from remote */
    async deleteTokenGroup(designSystemId, versionId, tokenGroupToDelete, tokens, tokenGroups) {
        const toDelete = this.itemsToDeleteFromGroup(tokenGroupToDelete, tokens, tokenGroups);
        return this.writeTokenData(designSystemId, versionId, [], [], toDelete.itemsToDelete, toDelete.groupsToDelete);
    }
    flattenedChildren(group, allItems, allItemGroups) {
        const resultItems = [];
        const resultGroups = [];
        // Find all immediate children
        const childItems = allItems.filter((t) => group.childrenIds.includes(t.id));
        const childGroups = allItemGroups.filter((g) => group.childrenIds.includes(g.id));
        resultItems.push(...childItems);
        resultGroups.push(...childGroups);
        // Find all nested children
        for (const childGroup of childGroups) {
            const result = this.flattenedChildren(childGroup, allItems, allItemGroups);
            resultItems.push(...result.items);
            resultGroups.push(...result.groups);
        }
        return {
            items: resultItems,
            groups: resultGroups,
        };
    }
    itemsToDeleteFromGroup(group, allItems, allItemGroups) {
        const children = this.flattenedChildren(group, allItems, allItemGroups);
        return {
            itemsToDelete: [...children.items],
            groupsToDelete: [group, ...children.groups],
        };
    }
    /** Update token property at remote */
    async updateTokenPropertyValue(designSystemId, versionId, newValue, token, property) {
        return this.write.updateTokenPropertyValue(designSystemId, versionId, newValue, token.id, property.id);
    }
    /** Delete token property in remote */
    async deleteTokenPropertyValue(designSystemId, versionId, valueId) {
        return this.write.deleteTokenPropertyValue(designSystemId, versionId, valueId);
    }
    /** Create a custom property in remote */
    async createTokenProperty(designSystemId, versionId, model) {
        const payload = {
            meta: {
                name: model.name,
                description: model.description,
            },
            type: model.type,
            targetElementType: ElementPropertyTargetElementType.token,
            codeName: model.codeName,
            columnWidth: model.columnWidth,
            linkElementType: model.linkElementType,
            options: model.options,
            persistentId: uuidv4(),
        };
        const remoteProperty = await this.write.createTokenProperty(designSystemId, versionId, payload);
        return {
            id: remoteProperty.persistentId,
            idInVersion: remoteProperty.id,
        };
    }
    /** Create a page within documentation */
    async createDocumentationPage(designSystemId, versionId, payload) {
        const persistentId = uuidv4();
        await this.write.createRemoteDocumentationPage(designSystemId, versionId, Object.assign(Object.assign({}, payload), { persistentId }));
        return persistentId;
    }
    /** General element action */
    async elementAction(designSystemId, versionId, data) {
        return this.write.elementAction(designSystemId, versionId, data);
    }
    /** Bulk update properties */
    async updateElementProperties(designSystemId, versionId, data) {
        return this.write.updateElementProperties(designSystemId, versionId, data);
    }
    /** Update page approval state */
    async updateApprovalState(designSystemId, versionId, payload) {
        return this.write.updateApprovalState(designSystemId, versionId, payload);
    }
    /** Update design system's access mode and, if switching to invite-only, also the member list */
    async updateDesignSystemAccessModeAndMemberList(designSystemId, accessMode, retainUserIds, retainInviteIds) {
        return this.write.updateRemoteDesignSystemAccessModeAndMemberList(designSystemId, accessMode, retainUserIds, retainInviteIds);
    }
    /** Update design system's member list */
    async updateDesignSystemMemberList(designSystemId, usersToInvite, invitesToInvite, emailsToInvite, invitesToUpdate, deleteInvitationIds, usersToUpdate, removeUserIds) {
        return this.write.updateRemoteDesignSystemMemberList(designSystemId, usersToInvite, invitesToInvite, emailsToInvite, invitesToUpdate, deleteInvitationIds, usersToUpdate, removeUserIds);
    }
    /** Create a group within documentation */
    async createDocumentationGroup(designSystemId, versionId, payload) {
        const persistentId = uuidv4();
        await this.write.createRemoteDocumentationGroup(designSystemId, versionId, Object.assign(Object.assign({}, payload), { persistentId }));
        return persistentId;
    }
    /** Create a tab group within documentation */
    async createDocumentationTab(designSystemId, versionId, payload) {
        const persistentId = uuidv4();
        await this.write.createRemoteDocumentationTab(designSystemId, versionId, Object.assign(Object.assign({}, payload), { persistentId }));
        return persistentId;
    }
    /** Fetches entire documentation including content in the legacy format */
    async getFullDocumentationLegacyRepresentation(designSystemId, versionId, workspaceId) {
        const dataObjects = await this.read.getRemoteDocumentationFullLegacyModel(designSystemId, versionId);
        const configuration = new DocumentationLegacyConfiguration({
            host: "",
            isHidden: false,
            isPrivate: true,
            isPublic: true,
            selectedBrandId: "",
            serveDefaultVersionOnly: false,
            tabbed: false,
            renderCodePackageJson: "{}",
        }, null);
        const resolver = new DocumentationLegacyItemResolver([], configuration, designSystemId, "", versionId, "", undefined);
        const items = resolver.resolveItemData(dataObjects.pages, dataObjects.groups);
        return {
            rootGroup: items.find((item) => item.type === DocumentationLegacyItemType.group &&
                item.isRoot),
            allPages: items.filter((item) => item.type === DocumentationLegacyItemType.page),
            allGroups: items.filter((item) => item.type === DocumentationLegacyItemType.group),
        };
    }
    /** Ungroup a documentaiton group */
    async ungroupDocumentationGroup(designSystemId, versionId, payload) {
        await this.write.deleteRemoteDocumentationGroup(designSystemId, versionId, payload);
    }
    /** Updates a documentation group */
    async updateDocumentationGroup(designSystemId, versionId, payload) {
        return this.write.updateRemoteDocumentationGroup(designSystemId, versionId, payload);
    }
    /** Updates a documentation page or tab */
    async updateDocumentationPageOrTab(designSystemId, versionId, payload) {
        return this.write.updateRemoteDocumentationPage(designSystemId, versionId, payload);
    }
    /** Move a documentation page */
    async moveDocumentationPage(designSystemId, versionId, payload) {
        return this.write.moveRemoteDocumentationPage(designSystemId, versionId, payload);
    }
    /** Move a documentation group */
    async moveDocumentationGroup(designSystemId, versionId, payload) {
        return this.write.moveRemoteDocumentationGroup(designSystemId, versionId, payload);
    }
    /** Duplicate a documentation page or tab */
    async duplicateDocumentationPageOrTab(designSystemId, versionId, payload) {
        const persistentId = uuidv4();
        await this.write.duplicateRemoteDocumentationPage(designSystemId, versionId, Object.assign(Object.assign({}, payload), { persistentId }));
        return persistentId;
    }
    /** Duplicate a documentation group or tabbed page */
    async duplicateDocumentationGroupOrTabbedPage(designSystemId, versionId, payload) {
        const persistentId = uuidv4();
        await this.write.duplicateRemoteDocumentationGroup(designSystemId, versionId, Object.assign(Object.assign({}, payload), { persistentId }));
        return persistentId;
    }
    /** Delete a documentation page */
    async deleteDocumentationPage(designSystemId, versionId, payload) {
        await this.write.deleteRemoteDocumentationPage(designSystemId, versionId, payload);
    }
    /** Delete a documentation tab group */
    async deleteDocumentationTabGroup(designSystemId, versionId, payload) {
        await this.write.deleteRemoteDocumentationTabGroup(designSystemId, versionId, payload);
    }
    /** Delete a documentation group */
    async deleteDocumentationGroup(designSystemId, versionId, payload) {
        await this.write.deleteRemoteDocumentationGroup(designSystemId, versionId, payload);
    }
    /** Delete a documentation group and tree inside it */
    async deleteDocumentationGroupAndTree(designSystemId, versionId, id) {
        await this.write.deleteRemoteDocumentationGroup(designSystemId, versionId, {
            id,
            deleteSubtree: true,
        });
    }
    /** Restore a documentation group */
    async restoreDocumentationGroup(designSystemId, versionId, payload) {
        await this.write.restoreRemoteDocumentationGroup(designSystemId, versionId, payload);
    }
    /** Restore a documentation page   */
    async restoreDocumentationPage(designSystemId, versionId, payload) {
        await this.write.restoreRemoteDocumentationPage(designSystemId, versionId, payload);
    }
    /** Create a custom property in remote */
    async updateTokenProperty(designSystemId, versionId, propertyIdInVersion, model) {
        const payload = {
            meta: {
                name: model.name,
                description: model.description,
            },
            codeName: model.codeName,
            options: model.options,
        };
        return this.write.updateTokenProperty(designSystemId, versionId, propertyIdInVersion, payload);
    }
    /** Delete a custom property in remote */
    async deleteTokenProperty(designSystemId, versionId, propertyId) {
        return this.write.deleteTokenProperty(designSystemId, versionId, propertyId);
    }
    /** Move column to a new index and reorder all other columns around it */
    async updateReorderTokenColumn(designSystemId, versionId, view, column, newIndex) {
        return this.write.updateReorderTokenColumn(designSystemId, versionId, view.id, column.id, newIndex);
    }
    /** Update column size */
    async updateResizeTokenColumn(designSystemId, versionId, view, column, newWidth) {
        var _a, _b, _c;
        return this.write.updateResizeTokenColumn(designSystemId, versionId, view.id, column.type, column.id, (_a = column.themeId) !== null && _a !== void 0 ? _a : undefined, (_b = column.basePropertyType) !== null && _b !== void 0 ? _b : undefined, (_c = column.propertyDefinitionId) !== null && _c !== void 0 ? _c : undefined, newWidth);
    }
    /** Delete theme from remote */
    async deleteTokenTheme(designSystemId, versionId, themeId) {
        return this.write.deleteRemoteTokenTheme(designSystemId, versionId, themeId);
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Elements: Components
    /** Download all necessary data for components and retrieve them resolved  */
    async components(designSystemId, versionId, filter) {
        // Batch requests together
        const data = await Promise.all([
            this.read.getRemoteComponents(designSystemId, versionId, filter),
            this.elementPropertyDefinitions(designSystemId, versionId, ElementPropertyTargetElementType.component),
            this.elementPropertyValues(designSystemId, versionId),
            this.elementViews(designSystemId, versionId, ElementPropertyTargetElementType.component),
        ]);
        const componentData = data[0];
        const elementPropertyDefinitions = data[1];
        const elementPropertyValues = data[2];
        const elementViews = data[3];
        const resolver = new ComponentResolver();
        const components = resolver.resolveComponentData(componentData, elementPropertyDefinitions, elementPropertyValues, elementViews);
        return components;
    }
    /** Download all necessary data for component groups and retrieve them resolved */
    async componentGroups(designSystemId, versionId) {
        const data = await Promise.all([
            this.read.getRemoteComponentGroups(designSystemId, versionId),
            this.components(designSystemId, versionId),
        ]);
        const componentGroupData = data[0];
        const components = data[1];
        const resolver = new ComponentGroupResolver(components);
        const groups = resolver.resolveGroupData(componentGroupData);
        return groups;
    }
    async designComponents(designSystemId, versionId, filter) {
        // Batch requests
        const data = await Promise.all([
            this.read.getRemoteDesignComponents(designSystemId, versionId, filter),
            this.designSystemSources(designSystemId),
        ]);
        const [designComponentData, sources] = data;
        return RawUtils.buildDesignComponentsFromRaw(designComponentData, sources);
    }
    async designComponentGroups(designSystemId, versionId, filter) {
        const data = await Promise.all([
            this.read.getRemoteDesignComponentGroups(designSystemId, versionId, filter),
            this.designComponents(designSystemId, versionId, filter),
        ]);
        const designComponentGroupData = data[0];
        const designComponents = data[1];
        return RawUtils.buildDesignComponentGroupsFromRaw(designComponentGroupData, designComponents);
    }
    /** Write new component to remote */
    async createComponent(designSystemId, versionId, component
    // parentId: string
    ) {
        const componentWriteObject = component.toWriteObject();
        // componentWriteObject.groupPersistentId = parentId <- Enable this once we support groups
        const remoteComponent = await this.write.createRemoteComponent(designSystemId, versionId, componentWriteObject);
        return {
            id: remoteComponent.persistentId,
            idInVersion: remoteComponent.id,
        };
    }
    /** Update existing component in remote */
    async updateComponent(designSystemId, versionId, component) {
        const componentWriteObject = component.toWriteUpdateObject();
        await this.write.updateRemoteComponent(designSystemId, versionId, componentWriteObject);
    }
    /** Write new component group to remote */
    async createComponentGroup(designSystemId, versionId, group
    // parentId: string
    ) {
        const groupWriteObject = group.toWriteObject();
        // groupWriteObject.parentId = parentId
        const remoteGroup = await this.write.createRemoteComponentGroup(designSystemId, versionId, groupWriteObject);
        return {
            id: remoteGroup.persistentId,
            idInVersion: remoteGroup.id,
        };
    }
    /** Update existing component group in remote */
    async updateComponentGroup(designSystemId, versionId, group) {
        const componentGroupWriteObject = group.toWriteObject();
        await this.write.updateRemoteComponentGroup(designSystemId, versionId, componentGroupWriteObject);
    }
    /** Update component property at remote */
    async updateComponentPropertyValue(designSystemId, versionId, newValue, component, property) {
        return this.write.updateComponentPropertyValue(designSystemId, versionId, newValue, component.id, property.id);
    }
    /** Delete component property in remote */
    async deleteComponentPropertyValue(designSystemId, versionId, valueId) {
        return this.write.deleteComponentPropertyValue(designSystemId, versionId, valueId);
    }
    /** Create a custom property in remote */
    async createComponentProperty(designSystemId, versionId, model) {
        const payload = {
            meta: {
                name: model.name,
                description: model.description,
            },
            type: model.type,
            targetElementType: ElementPropertyTargetElementType.component,
            codeName: model.codeName,
            columnWidth: model.columnWidth,
            linkElementType: model.linkElementType,
            options: model.options,
            persistentId: uuidv4(),
        };
        const remoteProperty = await this.write.createComponentProperty(designSystemId, versionId, payload);
        return {
            id: remoteProperty.persistentId,
            idInVersion: remoteProperty.id,
        };
    }
    /** Create a custom property in remote */
    async updateComponentProperty(designSystemId, versionId, propertyIdInVersion, model) {
        const payload = {
            meta: {
                name: model.name,
                description: model.description,
            },
            codeName: model.codeName,
            options: model.options,
        };
        return this.write.updateComponentProperty(designSystemId, versionId, propertyIdInVersion, payload);
    }
    /** Delete a custom property in remote */
    async deleteComponentProperty(designSystemId, versionId, propertyId) {
        return this.write.deleteComponentProperty(designSystemId, versionId, propertyId);
    }
    /** Move column to a new index and reorder all other columns around it */
    async updateReorderComponentColumn(designSystemId, versionId, view, column, newIndex) {
        return this.write.updateReorderComponentColumn(designSystemId, versionId, view.id, column.id, newIndex);
    }
    /** Update column size */
    async updateResizeComponentColumn(designSystemId, versionId, view, column, newWidth) {
        var _a, _b, _c;
        return this.write.updateResizeComponentColumn(designSystemId, versionId, view.id, column.type, column.id, (_a = column.themeId) !== null && _a !== void 0 ? _a : undefined, (_b = column.basePropertyType) !== null && _b !== void 0 ? _b : undefined, (_c = column.propertyDefinitionId) !== null && _c !== void 0 ? _c : undefined, newWidth);
    }
    /** Delete component from remote */
    async deleteComponent(designSystemId, versionId, componentId) {
        return this.write.deleteRemoteComponent(designSystemId, versionId, componentId);
    }
    /** Delete group from remote */
    async ungroupComponentGroup(designSystemId, versionId, groupId) {
        return this.write.ungroupRemoteComponentGroup(designSystemId, versionId, groupId);
    }
    /** Delete group from remote */
    async deleteComponentGroup(designSystemId, versionId, componentGroupToDelete, components, componentGroups) {
        const toDelete = this.itemsToDeleteFromGroup(componentGroupToDelete, components, componentGroups);
        return this.writeComponentData(designSystemId, versionId, [], [], toDelete.itemsToDelete, toDelete.groupsToDelete);
    }
    /** Write the component to remote */
    async writeComponentData(designSystemId, versionId, components, groups, deleteComponents, deleteGroups) {
        return this.write.writeComponentData(designSystemId, versionId, components.map((t) => t.toWriteObject()), groups.map((g) => g.toWriteObject()), deleteComponents, deleteGroups);
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Elements: Code Components
    /** Download all necessary data for code components and retrieve them resolved */
    async codeComponents(designSystemId, versionId) {
        // Batch requests
        const data = await this.read.getRemoteCodeComponents(designSystemId, versionId);
        return data.map((t) => new CodeComponent(t));
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Elements: Assets
    /** Download all necessary data for assets and retrieve them resolved */
    async assets(designSystemId, versionId) {
        // Batch requests
        const data = await Promise.all([
            this.read.getRemoteAssets(designSystemId, versionId),
            this.designSystemSources(designSystemId),
        ]);
        const assetData = data[0];
        const sources = data[1];
        // Manage duplicates
        const assetNames = new Map();
        for (const item of assetData) {
            if (item.exportProperties.isAsset) {
                assetNames.set(item.meta.name.toLowerCase(), 0);
            }
        }
        // Transform only exportable designComponents into assets
        const assets = [];
        for (const asset of assetData) {
            const lowercasedName = asset.meta.name.toLowerCase();
            if (asset.exportProperties.isAsset) {
                // @ts-expect-error TS(2345): Argument of type 'number | undefined' is not assig... Remove this comment to see the full error message
                assets.push(new Asset(asset, assetNames.get(lowercasedName), sources));
                // Increase number of duplicates
                // @ts-expect-error TS(2532): Object is possibly 'undefined'.
                // TODO:fix-sdk-eslint
                // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                assetNames.set(lowercasedName, assetNames.get(lowercasedName) + 1);
            }
        }
        return assets;
    }
    /** Download all necessary data for asset groups and retrieve them resolved */
    async assetGroups(designSystemId, versionId) {
        const data = await Promise.all([
            this.read.getRemoteAssetGroups(designSystemId, versionId),
            this.assets(designSystemId, versionId),
        ]);
        const assetGroupData = data[0];
        const assets = data[1];
        const resolver = new AssetGroupResolver(assets);
        const result = resolver.resolveGroupData(assetGroupData);
        return result;
    }
    /** Render assets as PNG, SVG, PDF, or combinations of it */
    async renderedAssets(designSystemId, versionId, assets, groups, settings) {
        return this.render.renderAssetsForConfiguration(designSystemId, versionId, settings, assets, groups);
    }
    /** Render Figma frames */
    async renderedFigmaFrames(designSystemId, versionId, payload) {
        const result = await this.write.renderFigmaFrames(designSystemId, versionId, payload);
        return result;
    }
    /** Render Figma frames async */
    async renderedFigmaFramesAsync(designSystemId, versionId, payload) {
        const result = await this.write.renderFigmaFramesAsync(designSystemId, versionId, payload);
        return result;
    }
    /** Fetches all Figma frames that were rendered under specific version
     * @param from - Remote version to fetch from
     * @returns All Figma frames in the specified version (only rendered, for documentation etc.)
     */
    async figmaFrames(designSystemId, versionId) {
        return this.read.getRemoteFigmaFrames(designSystemId, versionId);
    }
    /** Fetches all Figma frames that were rendered under specific version (V2 of the API)
     * @param from - Remote version to fetch from
     * @returns All Figma frames in the specified version (only rendered, for documentation etc.)
     */
    async figmaFramesV2(designSystemId, versionId) {
        return this.read.getRemoteFigmaFramesV2(designSystemId, versionId);
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - DocumentationLegacy
    /** Retrieve the main documentation object through which all docs data can be accessed */
    async documentation(workspaceId, designSystemId, versionId) {
        // Batch requests together
        const data = await Promise.all([
            this.read.getRemoteDocumentationStructure(designSystemId, versionId),
            this.workspaceNPMRegistrySettings(workspaceId),
        ]);
        const documentationData = data[0];
        const registry = data[1];
        const docs = new DocumentationLegacy(documentationData, registry);
        return docs;
    }
    async getDocumentationStructure(designSystemId, versionId) {
        return this.read.getRemoteRealDocumentationStructure(designSystemId, versionId);
    }
    async getDocumentationElementsDiff(designSystemId, versionId, environment) {
        return this.read.getRemoteDocumentationElementsDiff(designSystemId, versionId, environment);
    }
    async updateDocumentationStructure(designSystemId, versionId, model) {
        await this.write.updateRemoteDocumentationStructure(designSystemId, versionId, model);
    }
    /** Get ID of the multiplayer room for a given documentation page */
    async getDocumentationPageRoomId(designSystemId, versionId, pageId) {
        return this.read.getRemoteDocumentationPageRoomId(designSystemId, versionId, pageId);
    }
    /** Remote: Get id of the room for a specific design system and version. This room contains doc structure */
    async getDocumentationVersionRoomId(designSystemId, versionId) {
        return this.read.getRemoteDocumentationVersionRoomId(designSystemId, versionId);
    }
    /** Remote: Get id of the room for a specific Workspace. This room contains comments */
    async getDocumentationWorkspaceRoomId(workspaceId) {
        return this.read.getRemoteDocumentationWorkspaceRoomId(workspaceId);
    }
    /** Retrieve currently deployed documentation url */
    async documentationDomain(designSystemId, versionId) {
        const data = await this.read.getRemoteDocumentationUrl(designSystemId, versionId);
        return data;
    }
    /** Publish the documentation */
    async documentationPublish(workspaceId, designSystemId, versionId, environment) {
        const data = await this.write.publishDocumentation(workspaceId, designSystemId, versionId, environment);
        return new ExportBuild(data);
    }
    /** Publish the documentation drafts */
    async documentationPublishDrafts(designSystemId, versionId, environment, changes) {
        const data = await this.write.publishDocumentationDrafts(designSystemId, versionId, environment, changes);
        return new ExportBuild(data);
    }
    async getDocumentationPageAnchors(designSystemId, versionId, pageId) {
        const data = await this.read.getRemoteDocumentationPageAnchors(designSystemId, versionId, pageId);
        return data.anchors;
    }
    async getDocumentationDependencies(designSystemId, versionId) {
        return this.read.getRemoteDocumentationPageDependencies(designSystemId, versionId);
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Docs analytics
    async docsPageAnalytics(designSystemId, versionId, timeFrames) {
        const data = await this.read.getRemoteDocsPageAnalytics(designSystemId, versionId, timeFrames);
        return new DocsAnalyticsData(data);
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Resources
    /** Retrieve all asset resources */
    async assetResources(designSystemId, versionId) {
        const data = await this.read.getRemoteAssetResources(designSystemId, versionId);
        return data.map((d) => new ResourceAsset(d));
    }
    /** Retrieve all font resources */
    async fontResources(designSystemId, versionId) {
        const data = await this.read.getRemoteFontResources(designSystemId, versionId);
        return data.map((d) => new ResourceFont(d));
    }
    /** Retrieve all files */
    async files(designSystemId, versionId) {
        return this.read.getRemoteFiles(designSystemId, versionId);
    }
    /** Upload asset resource */
    async uploadAssetResource(designSystemId, versionId, asset) {
        const data = await this.write.uploadAssetResource(designSystemId, versionId, asset);
        return new ResourceAsset(data);
    }
    /** Upload font resource */
    async uploadFontResource(designSystemId, versionId, font) {
        const data = await this.write.uploadFontResource(designSystemId, versionId, font);
        if (data) {
            return new ResourceFont(data);
        }
        return null;
    }
    /** Upload font resources */
    async uploadFontResources(designSystemId, versionId, fonts) {
        const data = await this.write.uploadFontResources(designSystemId, versionId, fonts);
        return data.map((d) => new ResourceFont(d));
    }
    /** Delete any single resource */
    async deleteResource(designSystemId, versionId, resourceId) {
        return this.write.deleteResource(designSystemId, versionId, resourceId);
    }
    /** Delete any multiple resources */
    async deleteResources(designSystemId, versionId, resourceIds) {
        return this.write.deleteResources(designSystemId, versionId, resourceIds);
    }
    async initializeFileUpload(designSystemId, versionId, fileUploadItems) {
        return this.write.initializeFileUpload(designSystemId, versionId, fileUploadItems);
    }
    async finalizeFileUpload(designSystemId, versionId, fileIds) {
        return this.write.finalizeFileUpload(designSystemId, versionId, fileIds);
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Pipelines
    async pipelines(workspaceId, designSystemId) {
        const data = await this.read.getRemotePipelines(workspaceId, designSystemId);
        return data.map((d) => new Pipeline(d));
    }
    async createPipeline(workspaceId, payload) {
        const data = await this.write.createRemotePipeline(workspaceId, payload);
        return new Pipeline(data);
    }
    async updatePipeline(designSystemId, pipelineId, payload) {
        const data = await this.write.updateRemotePipeline(designSystemId, pipelineId, payload);
        return new Pipeline(data);
    }
    async runPipeline(workspaceId, designSystemVersionId, pipelineId) {
        const data = await this.write.runRemotePipeline(workspaceId, designSystemVersionId, pipelineId);
        return new ExportBuild(data);
    }
    async deletePipeline(workspaceId, pipelineId) {
        await this.write.deleteRemotePipeline(workspaceId, pipelineId);
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Exporters
    /** Download information about current exporter custom blocks and retrieve them resolved */
    async documentationExporterCustomBlocks(designSystemId, versionId) {
        const data = await this.read.getRemoteExporterCustomBlocks(designSystemId, versionId);
        const resolved = data.map((b) => new ExporterCustomBlock(b));
        return resolved;
    }
    /** Download information about current exporter custom block variants and retrieve them resolved */
    async documentationExporterCustomVariants(workspaceId, exporterId) {
        const data = await this.exporter(workspaceId, exporterId);
        return data.contributes.blockVariants;
    }
    /** Download information about user settings (definitions) of the exporter and retrieve it resolved */
    async exporterConfigurationProperties(exporterId, workspaceId, designSystemId) {
        // Batch requests together
        const data = await Promise.all([
            this.exporterConfigurationPropertyValues(exporterId, designSystemId),
            this.exporter(workspaceId, exporterId),
        ]);
        const propertyValues = data[0];
        const exporter = data[1];
        // Update properties with the downloaded data
        for (const property of exporter.contributes.configuration) {
            for (const settings of propertyValues) {
                if (property.key === settings.key) {
                    // TODO:fix-sdk-eslint
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                    property.updateValue(settings.value);
                }
            }
        }
        return exporter.contributes.configuration;
    }
    /** Download information about user settings (values) of the exporter and retrieve it resolved */
    async exporterConfigurationPropertyValues(exporterId, designSystemId) {
        const data = await this.read.getRemoteExporterConfigurationUserSpecifiedValues(designSystemId, exporterId);
        return data; // Note that no resolution is needed because data are served correctly from the server
    }
    /** Download information about installed exporter and retrieve it resolved */
    async exporter(workspaceId, exporterId) {
        const data = await this.read.getRemoteExporter(workspaceId, exporterId);
        return new Exporter(data);
    }
    /** Download information about all installed exporter and retrieve it resolved */
    async exporters(workspaceId, filter) {
        const { exporters, membership } = await this.read.getRemoteExporters(workspaceId, filter);
        // Add isOwner property to each exporter based on the memberships
        return exporters.map((exporter) => {
            const { role } = membership.find((m) => m.exporterId === exporter.id) || {};
            return new Exporter(Object.assign(Object.assign({}, exporter), { isOwner: role === "Owner" }));
        });
    }
    /** Create new exporter and return Exporter as a result */
    async createExporter(workspaceId, payload) {
        const data = await this.write.createRemoteExporter(workspaceId, payload);
        return new Exporter(data);
    }
    /** Edit exporter */
    async updateExporter(workspaceId, exporterId, payload) {
        const data = await this.write.updateRemoteExporter(workspaceId, exporterId, payload);
        return new Exporter(data);
    }
    /** Update exporter configuration property value */
    async updateExporterConfigurationPropertyValue(designSystemId, exporterId, propertyKey, propertyValue) {
        await this.write.updateRemoteExporterConfigurationPropertyValue(designSystemId, exporterId, propertyKey, propertyValue);
    }
    /** Delete exporter configuration property value */
    async deleteExporterConfigurationPropertyValue(designSystemId, exporterId, propertyKey) {
        await this.write.deleteRemoteExporterConfigurationPropertyValue(designSystemId, exporterId, propertyKey);
    }
    /** Delete exporter */
    async deleteExporter(workspaceId, exporterId) {
        await this.write.deleteRemoteExporter(workspaceId, exporterId);
    }
    /** Pull updates for exporter */
    async pullLatestExporter(workspaceId, exporterId) {
        // Reason for empty payload is;
        // If it's not passed - BE uses stored git url and pulls changes from exporter
        const data = await this.write.updateRemoteExporter(workspaceId, exporterId, {});
        return new Exporter(data);
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Projects
    async getForgeProjects(workspaceId) {
        const data = await this.read.getRemoteForgeProjects(workspaceId);
        return data.map((d) => new ForgeProject(d));
    }
    async getForgeProjectContexts(workspaceId) {
        const data = await this.read.getRemoteForgeProjectContexts(workspaceId);
        return data.map((d) => new ForgeProjectContext(d));
    }
    async getForgeAgents(workspaceId, projectId) {
        const data = await this.read.getRemoteForgeAgents(workspaceId, projectId);
        return data.map((d) => new ForgeAgent(d));
    }
    async updateForgeProject(workspaceId, projectId, data) {
        const updatedProject = await this.write.updateRemoteForgeProject(workspaceId, projectId, data);
        return new ForgeProject(updatedProject);
    }
    async deleteForgeProject(workspaceId, projectId) {
        return this.write.deleteRemoteForgeProject(workspaceId, projectId);
    }
    async getForgeProjectMemberships(workspaceId, projectId) {
        return (await this.read.getRemoteForgeProjectMemberships(workspaceId, projectId)).map((membership) => new ForgeProjectMembership(membership));
    }
    async createForgeProject(workspaceId, data) {
        const createdProject = await this.write.createRemoteForgeProject(workspaceId, data);
        return new ForgeProject(createdProject);
    }
    async createForgeProjectMember(workspaceId, projectId, data) {
        const createdMember = await this.write.createRemoteForgeProjectMember(workspaceId, projectId, data);
        return new ForgeProjectMembership(createdMember);
    }
    async updateForgeProjectMember(workspaceId, projectId, memberId, data) {
        const updatedMember = await this.write.updateRemoteForgeProjectMember(workspaceId, projectId, memberId, data);
        return new ForgeProjectMembership(updatedMember);
    }
    /** Generic project action */
    async projectAction(workspaceId, projectId, data) {
        const response = await this.write.projectAction(workspaceId, projectId, data);
        return response;
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Project Features
    async getForgeProjectFeature(workspaceId, projectId, featureId) {
        const data = await this.read.getRemoteForgeProjectFeature(workspaceId, projectId, featureId);
        return new ForgeProjectFeature(data);
    }
    async getForgeProjectFeatures(workspaceId, projectId) {
        const data = await this.read.getRemoteForgeProjectFeatures(workspaceId, projectId);
        return data.map((feature) => new ForgeProjectFeature(feature));
    }
    async createForgeProjectFeature(workspaceId, projectId, input, tId) {
        await this.write.projectAction(workspaceId, projectId, {
            type: "FeatureCreate",
            input,
            tId,
        });
    }
    async updateForgeProjectFeature(workspaceId, projectId, input, tId) {
        await this.write.projectAction(workspaceId, projectId, {
            type: "FeatureUpdate",
            input,
            tId,
        });
    }
    async deleteForgeProjectFeature(workspaceId, projectId, input, tId) {
        await this.write.projectAction(workspaceId, projectId, {
            type: "FeatureDelete",
            input,
            tId,
        });
    }
    async moveForgeProjectFeature(workspaceId, projectId, input, tId) {
        await this.write.projectAction(workspaceId, projectId, {
            type: "FeatureMove",
            input,
            tId,
        });
    }
    async getForgeProjectFeatureMessages(workspaceId, projectId, featureId) {
        const data = await this.read.getRemoteForgeProjectFeatureMessages(workspaceId, projectId, featureId);
        return new ForgeProjectFeatureMessageList(data);
    }
    async createForgeProjectFeatureMessage(workspaceId, projectId, featureId, input) {
        const data = await this.write.createRemoteForgeProjectFeatureMessage(workspaceId, projectId, featureId, input);
        return new ForgeProjectFeatureMessage(data);
    }
    async createForgeProjectFeatureMessageReaction(workspaceId, projectId, featureId, input) {
        const data = await this.write.createRemoteForgeProjectFeatureMessageReaction(workspaceId, projectId, featureId, input);
        return new ForgeProjectFeatureMessageReaction(data);
    }
    async removeForgeProjectFeatureMessageReaction(workspaceId, projectId, featureId, input) {
        await this.write.removeRemoteForgeProjectFeatureMessageReaction(workspaceId, projectId, featureId, input);
    }
    async getForgeProjectFeatureArtifacts(workspaceId, projectId, featureId) {
        const data = await this.read.getRemoteForgeProjectFeatureArtifacts(workspaceId, projectId, featureId);
        return new ForgeProjectFeatureArtifactList(data);
    }
    async createForgeProjectFeatureArtifact(workspaceId, projectId, featureId, input) {
        const data = await this.write.createRemoteForgeProjectFeatureArtifact(workspaceId, projectId, featureId, input);
        return new ForgeProjectFeatureArtifact(data.artifact);
    }
    async deleteForgeProjectFeatureArtifact(workspaceId, projectId, featureId, input) {
        await this.write.deleteRemoteForgeProjectFeatureArtifact(workspaceId, projectId, featureId, input);
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Project Artifacts
    async getForgeProjectArtifact(workspaceId, projectId, artifactId) {
        const data = await this.read.getRemoteForgeProjectArtifact(workspaceId, projectId, artifactId);
        return new ForgeProjectArtifact(data);
    }
    async getForgeProjectArtifacts(workspaceId, projectId) {
        const data = await this.read.getRemoteForgeProjectArtifacts(workspaceId, projectId);
        return data.map((artifact) => new ForgeProjectArtifact(artifact));
    }
    async createForgeProjectArtifact(workspaceId, projectId, input, tId) {
        await this.write.projectAction(workspaceId, projectId, {
            type: "ArtifactCreate",
            input,
            tId,
        });
    }
    async updateForgeProjectArtifact(workspaceId, projectId, input, tId) {
        await this.write.projectAction(workspaceId, projectId, {
            type: "ArtifactUpdate",
            input,
            tId,
        });
    }
    async deleteForgeProjectArtifact(workspaceId, projectId, input, tId) {
        await this.write.projectAction(workspaceId, projectId, {
            type: "ArtifactDelete",
            input,
            tId,
        });
    }
    async moveForgeProjectArtifact(workspaceId, projectId, input, tId) {
        await this.write.projectAction(workspaceId, projectId, {
            type: "ArtifactMove",
            input,
            tId,
        });
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Forge Sections
    async createForgeProjectSection(workspaceId, projectId, input, tId) {
        await this.write.projectAction(workspaceId, projectId, {
            type: "SectionCreate",
            input,
            tId,
        });
    }
    async updateForgeProjectSection(workspaceId, projectId, input, tId) {
        await this.write.projectAction(workspaceId, projectId, {
            type: "SectionUpdate",
            input,
            tId,
        });
    }
    async deleteForgeProjectSection(workspaceId, projectId, input, tId) {
        await this.write.projectAction(workspaceId, projectId, {
            type: "SectionDelete",
            input,
            tId,
        });
    }
    async moveForgeProjectSection(workspaceId, projectId, input, tId) {
        await this.write.projectAction(workspaceId, projectId, {
            type: "SectionMove",
            input,
            tId,
        });
    }
    async getForgeProjectRoom(workspaceId, projectId) {
        const data = await this.read.getRemoteForgeProjectRoom(workspaceId, projectId);
        return data.room.id;
    }
    async getForgeProjectArtifactRoom(workspaceId, projectId, artifactId) {
        const data = await this.read.getRemoteForgeProjectArtifactRoom(workspaceId, projectId, artifactId);
        return data.room.id;
    }
    async getForgeProjectFeatureRoom(workspaceId, projectId, featureId) {
        const data = await this.read.getRemoteForgeProjectFeatureRoom(workspaceId, projectId, featureId);
        return data.room.id;
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Builds
    async exportBuilds(workspaceId, versionId) {
        const data = await this.read.getRemoteBuilds(workspaceId, versionId);
        return data.map((d) => new ExportBuild(d));
    }
    async exportBuild(workspaceId, buildId) {
        const data = await this.read.getRemoteBuild(workspaceId, buildId);
        return new ExportBuild(data);
    }
    /** Download information about documentation builds and retrieve it resolved */
    async documentationBuilds(workspaceId, versionId, environment, status, createdByUserId, limit = 1) {
        const data = await this.read.getRemoteBuilds(workspaceId, versionId, environment, limit, 0, undefined, undefined, ["documentation"], createdByUserId, status);
        return data.map((d) => new ExportBuild(d));
    }
    async buildLogs(workspaceId, buildId) {
        const data = await this.read.getRemoteBuildLogs(workspaceId, buildId);
        return data.map((d) => new ExportBuildResultLog(d));
    }
    /** Create a new exporter build */
    async createExporterBuild(workspaceId, designSystemId, versionId, exporterId, destinations, brandId, themePersistentIds, exporterConfigurationProperties, previewMode) {
        const data = await this.write.createExporterBuild(workspaceId, designSystemId, versionId, exporterId, destinations, brandId, themePersistentIds, exporterConfigurationProperties, previewMode);
        return new ExportBuild(data);
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Workspaces
    async workspaceProductFeatures(workspaceId) {
        const data = await this.read.getRemoteWorkspaceProductFeatures(workspaceId);
        return new SubscriptionProductFeatures(data);
    }
    /** Download information about a single workspace and retrieve it resolved */
    async workspace(workspaceId) {
        const data = await this.read.getRemoteWorkspaceDetail(workspaceId);
        return new Workspace(data);
    }
    /** Download information about a single workspace's integrations' */
    async workspaceIntegrations(workspaceId) {
        const data = await this.read.getRemoteWorkspaceIntegrations(workspaceId);
        return new WorkspaceIntegrations(data);
    }
    /** Download redirect url for oauth of specific workspace integration */
    async workspaceIntegrationRedirectUrl({ workspaceId, type, }) {
        const data = await this.read.getRemoteWorkspaceIntegrationRedirectUrl({
            workspaceId,
            type,
        });
        return new WorkspaceIntegrationOauthRequest(data);
    }
    /** Creates a new credential for a workspace integration via PAT */
    async createWorkspaceIntegrationAccessToken({ workspaceId, payload, }) {
        const data = await this.write.createRemoteWorkspaceIntegrationAccessToken(workspaceId, payload);
        return new WorkspaceIntegrations(data);
    }
    /** Delete workspace credential's integration connection */
    async deleteWorkspaceIntegrationCredential({ workspaceId, integrationId, credentialId, }) {
        const data = await this.write.deleteRemoteWorkspaceIntegrationCredential(workspaceId, integrationId, credentialId);
        return new WorkspaceIntegration(data);
    }
    /** Delete workspace integration */
    async deleteWorkspaceIntegration({ workspaceId, integrationId, }) {
        const data = await this.write.deleteRemoteWorkspaceIntegration(workspaceId, integrationId);
        return new WorkspaceIntegration(data);
    }
    /** Fetch git providers's organization */
    async fetchGitProvidersOrganization({ workspaceId, integrationId, }) {
        const data = await this.read.getRemoteWorkspaceIntegrationGitProvidersData({
            workspaceId,
            integrationId,
            operation: GitProviderEndpoints.Organizations,
        });
        return new GitProvidersOrganizations(data);
    }
    /** Fetch git providers's projects */
    async fetchGitProviderProjects({ workspaceId, integrationId, params, }) {
        const data = await this.read.getRemoteWorkspaceIntegrationGitProvidersData({
            workspaceId,
            integrationId,
            operation: GitProviderEndpoints.Projects,
            params,
        });
        return new GitProvidersProjects(data);
    }
    /** Fetch git providers's repositories */
    async fetchGitProviderRepositories({ workspaceId, integrationId, params, }) {
        const data = await this.read.getRemoteWorkspaceIntegrationGitProvidersData({
            workspaceId,
            integrationId,
            operation: GitProviderEndpoints.Repositories,
            params,
        });
        return new GitProvidersRepositories(data);
    }
    /** Fetch git providers's branches */
    async fetchGitProviderBranches({ workspaceId, integrationId, params, }) {
        const data = await this.read.getRemoteWorkspaceIntegrationGitProvidersData({
            workspaceId,
            integrationId,
            operation: GitProviderEndpoints.Branches,
            params,
        });
        return new GitProvidersBranches(data);
    }
    async createWorkspace(name) {
        const data = await this.write.createRemoteWorkspace(name);
        return new Workspace(data);
    }
    async createVersion(designSystemId, model) {
        const data = await this.write.createRemoteVersion(designSystemId, model);
        return new DesignSystemVersionCreate(data);
    }
    async editVersion(designSystemId, versionId, model) {
        await this.write.updateRemoteVersion(designSystemId, versionId, model);
    }
    async deleteVersion(designSystemId, versionId) {
        await this.write.deleteRemoteVersion(designSystemId, versionId);
    }
    async createBrand(designSystemId, versionId, model) {
        const data = await this.write.createRemoteBrand(designSystemId, 
        // TODO:fix-sdk-eslint
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        versionId, model);
        return new Brand(data);
    }
    async editBrand(designSystemId, versionId, brandId, brand) {
        await this.write.updateRemoteBrand(designSystemId, versionId, brandId, brand);
    }
    async deleteBrand(designSystemId, versionId, brandId) {
        await this.write.deleteRemoteBrand(designSystemId, versionId, brandId);
    }
    async deleteCustomDomain(designSystemId) {
        await this.write.deleteRemoteCustomDomain(designSystemId);
    }
    async updateCustomDomain(designSystemId, customerDomain) {
        const data = await this.write.updateRemoteCustomDomain(designSystemId, customerDomain);
        return new CustomDomain(data);
    }
    async startSslGenerationForCustomDomain(designSystemId) {
        await this.write.startSslGenerationForCustomDomain(designSystemId);
    }
    async workspaceOnboarding(workspaceId) {
        const data = await this.read.getRemoteWorkspaceOnboarding(workspaceId);
        // @ts-expect-error TS(2345): Argument of type 'WorkspaceOnboardingRemoteModel |... Remove this comment to see the full error message
        return new WorkspaceOnboarding(data);
    }
    async workspaceIPWhitelistSettings(workspaceId) {
        const data = await this.read.getRemoteWorkspaceIPWhitelistSettings(workspaceId);
        return data ? new WorkspaceIPWhitelistSettings(data) : null;
    }
    async workspaceNPMRegistrySettings(workspaceId) {
        const data = await this.read.getRemoteWorkspaceNPMRegistrySettings(workspaceId);
        return data ? new WorkspaceNPMRegistrySettings(data) : null;
    }
    async workspaceNPMRegistryAccessToken(workspaceId) {
        const data = await this.read.getRemoteWorkspaceNPMRegistryAccessToken(workspaceId);
        return data;
    }
    async workspaceSSOSettings(workspaceId) {
        const data = await this.read.getRemoteWorkspaceSSOSettings(workspaceId);
        return data ? new WorkspaceSSOSettings(data) : null;
    }
    async workspaceInvitations(workspaceId) {
        const data = await this.read.getRemoteWorkspaceInvitations(workspaceId);
        return data.map((m) => new WorkspaceInvitation(m));
    }
    async workspaceInvoices(workspaceId) {
        const data = await this.read.getRemoteWorkspaceInvoices(workspaceId);
        return data.map((m) => new WorkspaceInvoice(m));
    }
    async workspaceSubscription(workspaceId) {
        const data = await this.read.getRemoteWorkspaceSubscription(workspaceId);
        return new WorkspaceSubscription(data);
    }
    async workspaceAvailableProducts(workspaceId) {
        const data = await this.read.getRemoteWorkspaceAvailableProducts(workspaceId);
        return data.map((m) => new WorkspaceProduct(m));
    }
    async workspacePortalSettings(workspaceId) {
        const data = await this.read.getRemoteWorkspacePortalSettings(workspaceId);
        return new PortalSettings(data);
    }
    async updateWorkspacePortalSettings(workspaceId, settings) {
        return this.write.updateRemoteWorkspacePortalSettings(workspaceId, settings);
    }
    async updateWorkspaceProfile(workspaceId, profile) {
        return this.write.updateRemoteWorkspaceProfile(workspaceId, profile);
    }
    async testIpWhitelistSettings(workspaceId, ipWhitelistSettings) {
        return this.write.testIpWhitelistSettings(workspaceId, ipWhitelistSettings);
    }
    async updateWorkspaceOnboarding(workspaceId, state) {
        return this.write.updateRemoteWorkspaceOnboarding(workspaceId, state);
    }
    async updateWorkspaceAvatar(workspaceId, avatar) {
        return this.write.updateRemoteWorkspaceAvatar(workspaceId, avatar);
    }
    async updateWorkspaceSSOSettings(workspaceId, ssoSettings) {
        return this.write.updateRemoteWorkspaceSSOSettings(workspaceId, ssoSettings);
    }
    async updateWorkspaceIPWhitelistSettings(workspaceId, ipWhitelistSettings) {
        return this.write.updateRemoteWorkspaceIPWhitelistSettings(workspaceId, ipWhitelistSettings);
    }
    async updateWorkspaceNPMRegistrySettings(workspaceId, npmRegistrySettings) {
        return this.write.updateRemoteWorkspaceNPMRegistrySettings(workspaceId, npmRegistrySettings);
    }
    async updateUserWorkspaceNotificationSettings(userId, workspaceId, notificationSettings) {
        return this.write.updateUserWorkspaceNotificationSettings(userId, workspaceId, notificationSettings);
    }
    async updateWorkspaceOwnership(workspaceId, newOwnerUserId) {
        return this.write.updateRemoteWorkspaceOwnership(workspaceId, newOwnerUserId);
    }
    async updateWorkspaceMemberRole(workspaceId, userId, newRole, newSeatType) {
        return this.write.updateRemoteWorkspaceMemberRole(workspaceId, userId, newRole, newSeatType);
    }
    async updateWorkspaceInvitationRole(workspaceId, invitationId, newRole, newSeatType) {
        return this.write.updateRemoteWorkspaceInvitationRole(workspaceId, invitationId, newRole, newSeatType);
    }
    async addWorkspaceInvitations(workspaceId, invitations, designSystemId) {
        return this.write.addRemoteWorkspaceInvitations(workspaceId, invitations, designSystemId);
    }
    async deleteWorkspace(workspaceId) {
        return this.write.deleteRemoteWorkspace(workspaceId);
    }
    async deleteWorkspaceAvatar(workspaceId) {
        return this.write.deleteRemoteWorkspaceAvatar(workspaceId);
    }
    async deleteWorkspaceNPMRegistrySettings(workspaceId) {
        return this.write.deleteRemoteWorkspaceNPMRegistrySettings(workspaceId);
    }
    async deleteWorkspaceMember(workspaceId, userId) {
        return this.write.deleteRemoteWorkspaceMember(workspaceId, userId);
    }
    async deleteWorkspaceInvitation(workspaceId, invitationId) {
        return this.write.deleteRemoteWorkspaceInvitation(workspaceId, invitationId);
    }
    async createCheckoutSession(workspaceId, priceId, successUrl, cancelUrl, quantity) {
        return this.write.createRemoteCheckoutSession(workspaceId, priceId, successUrl, cancelUrl, quantity);
    }
    async createPortalSession(workspaceId, returnUrl, update, cancel) {
        return this.write.createRemotePortalSession(workspaceId, returnUrl, update, cancel);
    }
    async resendWorkspaceInvitation(workspaceId, invitationId, designSystemId) {
        return this.write.resendRemoteWorkspaceInvitation(workspaceId, invitationId, designSystemId);
    }
    async restoreWorkspaceSubscription(workspaceId) {
        return this.write.restoreRemoteWorkspaceSubscription(workspaceId);
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Design systems
    /** Download information about a single design system and retrieve it resolved */
    async designSystem(designSystemId) {
        const data = await this.read.getRemoteDesignSystem(designSystemId);
        return new DesignSystem(data);
    }
    /** Download information about design systems that user has access to under a single workspace and retrieve it resolved */
    async designSystems(workspaceId) {
        const data = await this.read.getRemoteDesignSystems(workspaceId);
        return data.map((d) => new DesignSystem(d));
    }
    /** Creates a design system */
    async createDesignSystem(workspaceId, name, description, accessMode, usersToInvite, invitesToInvite, emailsToInvite) {
        const data = await this.write.createRemoteDesignSystem(workspaceId, name, description, accessMode, usersToInvite, invitesToInvite, emailsToInvite);
        return new DesignSystem(data);
    }
    async getBlockDefinitions(designSystemId, versionId) {
        const data = await this.read.getBlockDefinitions(designSystemId, versionId);
        return data.map((item) => {
            return new DocsBlockDefinition(item);
        });
    }
    async getUrlPreview(designSystemId, versionId, request) {
        return this.read.getUrlPreview(designSystemId, versionId, request);
    }
    /** Updates a design system metadata */
    async updateDesignSystemMetadata(designSystemId, name, description) {
        await this.write.updateRemoteDesignSystemMetadata(designSystemId, name, description);
    }
    /** Updates a design system multibrand option */
    async updateDesignSystemIsMultibrand(designSystem, isMultibrand) {
        await this.write.updateRemoteDesignSystemIsMultibrand(designSystem, isMultibrand);
    }
    /** Updates a design system approval feature */
    async updateDesignSystemApprovalsFeature(designSystemId, payload) {
        await this.write.updateRemoteDesignSystemApprovalsFeature(designSystemId, payload);
    }
    /** Updates a design system switcher */
    async updateDesignSystemSwitcher(designSystem, designSystemSwitcher) {
        await this.write.updateRemoteDesignSystemSwitcher(designSystem, designSystemSwitcher);
    }
    /** Updates design system doc exporter id  */
    async updateDesignSystemDocExporterId(designSystem, docExporterId) {
        await this.write.updateRemoteDesignSystemDocExporterId(designSystem, docExporterId);
    }
    /** Updates a design system multibrand option */
    async updateDesignSystemDocumentationSlug(designSystem, docUserSlug) {
        await this.write.updateRemoteDesignSystemDocumentationSlug(designSystem, docUserSlug);
    }
    /** Delete a design system */
    async deleteDesignSystem(designSystemId) {
        await this.write.deleteDesignSystem(designSystemId);
    }
    /** Download information about a custom domain */
    async designSystemCustomDomain(designSystemId) {
        const data = await this.read.getRemoteCustomDomain(designSystemId);
        return new CustomDomain(data);
    }
    /** Get design system stats */
    async designSystemStats(dsId, versionId, brandId) {
        const data = await this.read.getRemoteDesignSystemStats(dsId, versionId, brandId);
        return new DesignSystemVersionStats(data);
    }
    /** Download information about a desing system source within a design system design and retrieve it resolved */
    async designSystemSource(designSystemId, sourceId) {
        const data = await this.read.getRemoteSource(designSystemId, sourceId);
        return new Source(data);
    }
    /** Download information about all design system sources within a design system design and retrieve it resolved */
    async designSystemSources(designSystemId, filter) {
        const data = await this.read.getRemoteSources(designSystemId, filter);
        return data.map((d) => new Source(d));
    }
    /** Download information about all design system members */
    async designSystemMemberList(designSystemId) {
        const data = await this.read.getRemoteDesignSystemMemberList(designSystemId);
        return new DesignSystemMemberList(data);
    }
    /** Download information about design system's contacts */
    async designSystemContacts(designSystemId) {
        const data = await this.read.getRemoteContacts(designSystemId);
        return new DesignSystemContactList(data);
    }
    async getFigmaNodeStructures(designSystemId) {
        const data = await this.read.getFigmaNodeStructures(designSystemId);
        return data.map((model) => new FigmaStructure(model));
    }
    async getFigmaNodeStructureDetail(designSystemId, figmaStructureId) {
        const data = await this.read.getFigmaNodeStructureDetail(designSystemId, figmaStructureId);
        return new FigmaStructureDetail(data);
    }
    async getStorybookEntries(designSystemId, versionId) {
        const data = await this.read.getStorybookEntries(designSystemId, versionId);
        return data.map((entry) => new StorybookEntry(entry));
    }
    async deleteFigmaSource(designSystemId, sourceId) {
        return this.write.deleteRemoteSource(designSystemId, sourceId);
    }
    async linkFigmaSource(designSystemId, brandId, url, options) {
        const payload = {
            figmaFileUrl: url,
            autoImportMode: options.autoImport,
            brandId,
            scope: options.scopes,
        };
        if (options.themeId) {
            // TODO:fix-sdk-eslint
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            payload.themeId = options.themeId;
        }
        // TODO:fix-sdk-eslint
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        const data = await this.write.linkSource(designSystemId, payload);
        return new Source(data);
    }
    async updateFigmaSource(designSystemId, sourceId, options) {
        const payload = {};
        if (options.scopes) {
            // TODO:fix-sdk-eslint
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            payload.scope = options.scopes;
        }
        // TODO:fix-sdk-eslint
        // eslint-disable-next-line no-prototype-builtins
        if (options.hasOwnProperty("autoImport")) {
            // TODO:fix-sdk-eslint
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            payload.autoImportMode = options.autoImport;
        }
        // TODO:fix-sdk-eslint
        // eslint-disable-next-line no-prototype-builtins
        if (options.hasOwnProperty("themeId")) {
            // TODO:fix-sdk-eslint
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            payload.themeId = options.themeId;
        }
        const data = await this.write.updateSource(designSystemId, sourceId, 
        // TODO:fix-sdk-eslint
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        payload);
        return new Source(data);
    }
    async linkStorybookSource(designSystemId, payload) {
        const data = await this.write.linkSource(designSystemId, payload);
        return new Source(data);
    }
    async updateStorybookSource(designSystemId, versionId, payload) {
        const data = await this.write.updateStorybookSource(designSystemId, versionId, payload);
        return data;
    }
    async replaceStorybookStory(designSystemId, versionId, storyId, payload) {
        const data = await this.write.replaceStorybookStory(designSystemId, versionId, storyId, payload);
        return data;
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Versions
    async versions(designSystemId) {
        const data = await this.read.getVersions(designSystemId);
        return data.map((d) => new DesignSystemVersion(d));
    }
    async version(designSystemId, versionId) {
        const data = await this.read.getVersion(designSystemId, versionId);
        return new DesignSystemVersion(data);
    }
    async versionCreationJob(designSystemId, jobId) {
        const data = await this.read.getVersionCreationJob(designSystemId, jobId);
        return new DesignSystemVersionCreationJob(data);
    }
    async versionCreationJobs(designSystemId) {
        const jobs = await this.read.getVersionCreationJobs(designSystemId);
        return jobs.map((job) => new DesignSystemVersionCreationJob(job));
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Brands
    async getBrands(designSystemId, versionId) {
        const data = await this.read.getBrands(designSystemId, versionId);
        return data.map((d) => new Brand(d));
    }
    async getBrand(designSystemId, versionId, brandId) {
        const data = await this.read.getBrand(designSystemId, versionId, brandId);
        return new Brand(data);
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Integrations
    getAuthenticationTokens() {
        return this.read.getAuthenticationTokens();
    }
    deleteAuthenticationToken(id) {
        return this.write.deleteAuthenticationToken(id);
    }
    createAuthenticationToken(name, scope) {
        return this.write.createAuthenticationToken(name, scope);
    }
    getOAuthURL(service) {
        return this.read.getOAuthURL(service);
    }
    deleteOAuthIntegration(userId, service) {
        return this.write.deleteOAuthIntegration(userId, service);
    }
    createPersonalAccessTokenConnection(service, connection) {
        return this.write.createPersonalAccessTokenConnection(service, connection);
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Transactions
    async bulkUpdateTokenData(designSystemId, versionId, data) {
        let primaryPromise = Promise.resolve();
        if (data.tokenMode === "create") {
            // Create token if it didn't exist. We don't have to update the top level group, because BE will do that for us
            const ids = await this.createToken(designSystemId, versionId, data.token, data.tokenParent.id);
            data.token.id = ids.id;
            data.token.idInVersion = ids.idInVersion;
        }
        else if (data.tokenMode === "update") {
            // Update token if it is not imported.
            // In this case, also update group where it belongs
            // but make sure that `this.updateToken` runs first and `this.updateTokenGroup` after it
            if (!TokenUtils.isTokenImported(data.token)) {
                primaryPromise = primaryPromise.then(() => this.updateToken(designSystemId, versionId, data.token));
            }
            primaryPromise = primaryPromise.then(() => this.updateTokenGroup(designSystemId, versionId, data.tokenParent));
        }
        // Add all secondary updates
        const secondaryPromises = new Array();
        if (data.propertyValuesToCreateOrUpdate) {
            data.propertyValuesToCreateOrUpdate.forEach((p) => {
                secondaryPromises.push(() => this.updateTokenPropertyValue(designSystemId, versionId, p.value, data.token, p.property));
            });
        }
        if (data.propertyValuesToDelete) {
            data.propertyValuesToDelete.forEach((p) => {
                secondaryPromises.push(() => this.deleteTokenPropertyValue(designSystemId, versionId, p));
            });
        }
        if (data.themeValuesToCreate) {
            data.themeValuesToCreate.forEach((themeOverride) => {
                secondaryPromises.push(() => this.createThemeOverrideForToken(designSystemId, versionId, themeOverride.themeId, themeOverride.themeOverrideTransferObject));
            });
        }
        if (data.themeValuesToUpdate) {
            data.themeValuesToUpdate.forEach((themeOverride) => {
                secondaryPromises.push(() => this.updateThemeOverrideForToken(designSystemId, versionId, data.token.id, themeOverride.themeId, themeOverride.themeOverrideTransferObject));
            });
        }
        if (data.themeValuesToDelete) {
            data.themeValuesToDelete.forEach((themeId) => {
                secondaryPromises.push(() => this.deleteThemeOverrideForToken(designSystemId, versionId, data.token.id, themeId));
            });
        }
        // NOTE: have the primary promise run first and secondary promises run after that
        await primaryPromise;
        await Promise.all(secondaryPromises.map((p) => p()));
    }
    async bulkUpdateComponentData(designSystemId, versionId, data) {
        let primaryPromise = Promise.resolve();
        if (data.componentMode === "create") {
            // Create component if it didn't exist. We don't have to update the top level group, because BE will do that for us
            const ids = await this.createComponent(designSystemId, versionId, data.component
            // data.componentParent.id
            );
            data.component.id = ids.id;
            data.component.idInVersion = ids.idInVersion;
        }
        else if (data.componentMode === "update") {
            // Update token because it did exist. In this case, also update group where it belongs
            // but make sure that `this.updateToken` runs first and `this.updateTokenGroup` after it
            primaryPromise = primaryPromise.then(() => this.updateComponent(designSystemId, versionId, data.component));
            // .then(() =>
            //   this.updateComponentGroup(
            //     designSystemId,
            //     versionId,
            //     data.componentParent
            //   )
            // )
        }
        // Add all secondary updates
        const secondaryPromises = new Array();
        if (data.propertyValuesToCreateOrUpdate) {
            data.propertyValuesToCreateOrUpdate.forEach((p) => {
                secondaryPromises.push(this.updateComponentPropertyValue(designSystemId, versionId, p.value, data.component, p.property));
            });
        }
        if (data.propertyValuesToDelete) {
            data.propertyValuesToDelete.forEach((p) => {
                secondaryPromises.push(this.deleteTokenPropertyValue(designSystemId, versionId, p));
            });
        }
        // NOTE: have the primary promise run first and secondary promises run after that
        await primaryPromise;
        await Promise.all(secondaryPromises);
    }
    async importTokens(designSystemId, brandId, sourceId, sourceName, sourceType, payload, isTokenTypeSplitEnabled) {
        const data = await this.write.importTokens(designSystemId, brandId, sourceId, sourceName, sourceType, "Upload", payload, isTokenTypeSplitEnabled);
        return new ImportJob(data);
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Automation
    async getImportJob(designSystemId, versionId, jobId) {
        const data = await this.read.getImportJob(designSystemId, versionId, jobId);
        return new ImportJob(data);
    }
    async getImportJobs(designSystemId, versionId) {
        const data = await this.read.getImportJobs(designSystemId, versionId);
        return data.map((d) => new ImportJob(d));
    }
    async scheduleImportJobForFigmaSources(designSystemId, versionId, sourceIds, dryRun) {
        const data = await this.write.scheduleImportJobForFigmaSources(designSystemId, versionId, sourceIds, dryRun);
        return new ImportJob(data);
    }
    async getTokenStudioData(designSystemId, versionId) {
        return this.read.getTokenStudioData(designSystemId, versionId);
    }
    async writeTokenStudioData(designSystemId, versionId, data) {
        return this.write.writeTokenStudioJSONData(designSystemId, versionId, data);
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Data storage
    async readKeyValueStorageData(designSystemId, key) {
        const data = await this.read.getKeyValueStorageData(designSystemId, [key]);
        return data;
    }
    async setKeyValueStorageData(designSystemId, key, value) {
        const stringValue = typeof value === "string" ? value : JSON.stringify(value, null, 0);
        await this.write.setKeyValueStorageData(designSystemId, {
            metadata: {
                [key]: stringValue,
            },
        });
    }
    async unsetKeyValueStorageData(designSystemId, key) {
        await this.write.setKeyValueStorageData(designSystemId, {
            metadata: { [key]: null },
        });
    }
    async getPageRedirects(designSystemId) {
        return this.read.getPageRedirects(designSystemId);
    }
    async createPageRedirect(designSystemId, body) {
        return this.write.createPageRedirect(designSystemId, body);
    }
    async updatePageRedirect(designSystemId, redirectId, body) {
        return this.write.updatePageRedirect(designSystemId, redirectId, body);
    }
    async deletePageRedirect(designSystemId, redirectId) {
        return this.write.deletePageRedirect(designSystemId, redirectId);
    }
    /** Remove a project member */
    async removeForgeProjectMember(workspaceId, projectId, data) {
        return this.write.removeForgeProjectMember(workspaceId, projectId, data);
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Messaging
    async listThreads(workspaceId, limit, offset) {
        const data = await this.read.getRemoteChatThreads(workspaceId, limit, offset);
        return data.threads.map((thread) => new ChatThread(thread));
    }
    async getChatThreadMessages(workspaceId, thread) {
        const data = await this.read.getRemoteChatThreadMessages(workspaceId, thread.id);
        const messages = data.messages.map((message) => new ChatThreadMessage(message));
        return thread.copyWithMessages(messages);
    }
    async getChatThreadMessagesByThreadId(workspaceId, threadId) {
        const data = await this.read.getRemoteChatThreadMessages(workspaceId, threadId);
        const messages = data.messages.map((message) => new ChatThreadMessage(message));
        return messages;
    }
    async createThread(workspaceId, title) {
        const data = await this.write.createRemoteChatThread(workspaceId, title !== null && title !== void 0 ? title : "Untitled");
        return new ChatThread(data.thread);
    }
    async updateThreadTitle(workspaceId, threadId, newTitle) {
        const data = await this.write.updateRemoteChatThreadTitle(workspaceId, threadId, newTitle);
        return new ChatThread(data.thread);
    }
    async createMessage(workspaceId, threadId, messageInput) {
        const data = await this.write.createRemoteChatMessage(workspaceId, threadId, messageInput);
        return new ChatThreadMessage(data.message);
    }
    async deleteThread(workspaceId, threadId) {
        await this.write.deleteRemoteChatThread(workspaceId, threadId);
    }
    async scoreChatThreadMessage(workspaceId, threadId, scores, tags) {
        await this.write.scoreChatThreadMessage(workspaceId, threadId, scores, tags);
    }
}
